import { Controller } from "@hotwired/stimulus"

// A floating call to action: it appears once the reader has moved past the first screen. Dismissing it hides it for this page view only,
// so it is back on the next visit or refresh; nothing is stored.
export default class extends Controller {
  static values = { after: { type: Number, default: 400 } }

  connect() {
    this.onScroll = () => { this.element.hidden = window.scrollY < this.afterValue }
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  dismiss() {
    window.removeEventListener("scroll", this.onScroll)
    this.element.hidden = true
  }
}
